module.exports = __webpack_public_path__ + "img/service.f6e687d5.png";